<template lang="pug">
.location-detail
  .location-detail__hero
    img.location-detail__background(:src="details.BannerImage")
  .location-detail__header
    .header__details
      p.header__eyebrow
        a(href="/locations") Back to Locations List
      h1.header__name {{ details.Name }}
      p.header__copy {{ details.StreetAddress }}
      p.header__copy {{ details.City }}, {{ details.State }} {{ details.PostalCode }}
      p.header__copy(v-if="geolocation") {{ details.distanceFrom }} Miles
    .header__actions
      button.header__btn(type="button", @click="getDirections()") Directions
      a.header__btn(:href="details.AppointmentUrl") Make an Appointment
  .location-detail__content
    .location-detail__content-hours
      .branch
        .branch__alert(v-if="details.AlertTitle")
          p.branch__alert-flair {{ details.AlertTitle }}
          p.branch__alert-copy(v-html="details.AlertCopy")
        .branch__hours
          template(v-if="!details.LobbyClosed")
            span.branch__hours-message(:class="{ 'closed': getHoursMessage('Lobby').closed }") {{ details.LobbyHours.HoursTitle }}
              p {{ getHoursMessage('Lobby').message }}
            .branch__hours-details
              span(v-for="day in details.LobbyHours.Days", :class="{ 'active': getIsToday(day) }")
                p {{ day.DayOfWeek }}
                p {{ getDayTimes(day) }}
          template(v-else)
            span.branch__hours-message.closed {{ details.LobbyHours.HoursTitle }}
              p {{ details.LobbyClosedMessage }}

        .branch__hours
          template(v-if="!details.DriveThruClosed")
            span.branch__hours-message(:class="{ 'closed': getHoursMessage('DriveThru').closed }") {{ details.DriveThruHours.HoursTitle }}
              p {{ getHoursMessage('DriveThru').message }}
            .branch__hours-details
              span(v-for="day in details.DriveThruHours.Days", :class="{ 'active': getIsToday(day) }")
                p {{ day.DayOfWeek }}
                p {{ getDayTimes(day) }}
          template(v-else)
            span.branch__hours-message.closed {{ details.DriveThruHours.HoursTitle }}
              p {{ details.DriveThruClosedMessage }}

        .branch__atm(v-if="details.ATMHours")
          span.branch__atm-message ATM Hours
          p.branch__atm-details {{ details.ATMHours }}
    .location-detail__content-map
      .map
      button.branch__holiday-closures(type="button", @click="details.ViewHolidayClosures = !details.ViewHolidayClosures") Holiday Closures
      .branch__holiday-closures-details(:class="{ 'visible': details.ViewHolidayClosures }", v-html="details.HolidayClosures")
      .branch__events
        template(v-if="details.EventDetails.length")
          h2 Upcoming Events
          .event-detail__event(v-for="event in details.EventDetails")
            .event-detail__details
              h3 {{ event.Title }}
              h4.event-detail__eyebrow DATE &amp; TIME
              p.event-detail__value {{ event.DateTimeLine1 }}
              p.event-detail__value {{ event.DateTimeLine2 }}
              template(v-if="event.Locations.length")
                h4(v-if="event.Locations.length === 1").event-detail__eyebrow LOCATION
                h4(v-else).event-detail__eyebrow LOCATIONS
                .event-detail__location(v-for="item in event.Locations")
                  p.event-detail__value {{ item.LocationTitle }}
                  p.event-detail__value {{ item.LocationLine1 }}
                  p.event-detail__value {{ item.LocationLine2 }}
                  p.event-detail__value {{ item.LocationLine3 }}
              .content(v-if="event.AdditionalInfo" style='margin-top:1rem') {{event.AdditionalInfo }}
              .event-detail__ctas
                a.event-detail__cta(:href="event.Link") View Event Details
</template>

<script>
import moment from 'moment';
import gmapsInit from "../utilities/gmaps";
import { mapGetters } from "vuex";

export default {
  props: ['settings'],
  data: () => ({

    geolocation: false,
    google: null,
    geocoder: null,
    map: null,
    map_options: {}
  }),
  computed: {
    ...mapGetters(["apiKey", "details", "options", "config"]),
  },
  methods: {
    getIsToday(el) {
      let day = moment(new Date()).format('dddd');
      return el.DayOfWeek === day;
    },
    getDayTimes(day) {
      if (day.Open) {
        return `${day.OpenTime} - ${day.CloseTime}`
      } {
        return 'Closed'
      }
    },
    getHoursMessage(type) {
      let format = 'hh:mm A'
      let day = moment(new Date()).format('dddd');
      let currentEl = this.details[`${type}Hours`].Days.find(el => el.DayOfWeek === day);
      let currentElIndex = this.details[`${type}Hours`].Days.findIndex(el => el.DayOfWeek === day);
      let firstOpenEl = this.details[`${type}Hours`].Days.find(el => el.Open);

      let message = null;
      let closed = true;
      let beforeTime = moment(currentEl.OpenTime, format);
      let afterTime = moment(currentEl.CloseTime, format);

      if (currentEl.Open && moment(new Date()).isBetween(beforeTime, afterTime)) {
        closed = false;
        message = `Open today until ${currentEl.CloseTime}`
      } else if (currentEl.Open && moment(new Date()).isBefore(beforeTime)) {
        message = `Closed until ${currentEl.DayOfWeek} at ${currentEl.OpenTime}`
      } else {
        this.details[`${type}Hours`].Days.forEach((el, i) => {
          if (message) return;
          if (i > currentElIndex) {
            if (el.Open) {
              message = `Closed until ${el.DayOfWeek} at ${el.OpenTime}`;
            } else if (firstOpenEl) {
              message = `Closed until ${firstOpenEl.DayOfWeek} at ${firstOpenEl.OpenTime}`
            }
            else {
              message = `Closed until further notice`
            }
          }
        })
      }

      return {
        closed: closed,
        message: message
      }
    },
    getDirections() {
      let link = document.createElement('a');
      let base = 'https://www.google.com/maps/dir/';
      let { StreetAddress, City, State, PostalCode, Latitude, Longitude } = this.details;
      StreetAddress = String(StreetAddress).trim().replace(/\s*?\(.*?\)\s*?/gmi, '');
      City = String(City).trim();
      State = String(State).trim();
      PostalCode = String(PostalCode).trim();
      Latitude = String(Latitude).trim();
      Longitude = String(Longitude).trim();

      let address = encodeURI(`United Heritage Credit Union,+${StreetAddress},+${City},+${State}+${PostalCode}`.replace(/\s+/gmi, '+'));
      let position = encodeURI(`@${Latitude},${Longitude}`);

      link.setAttribute('data-popup-trigger', '#popup_external');
      link.setAttribute('data-target', `${base}/${address}/${position}`);
      link.setAttribute('href', `${base}/${address}/${position}`);

      link.style.height = '0';
      link.style.width = '0';
      link.style.opacity = '0';
      link.style.position = 'absolute';
      link.style.overflow = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async findLocation() {
      navigator.geolocation.getCurrentPosition(async (position) => {
        let geoLat = position.coords.latitude;
        let geoLng = position.coords.longitude;

        this.details['distanceFrom'] = this.getDistance(geoLat, geoLng, this.details.Latitude, this.details.Longitude, "K")

        this.geolocation = true;
      }, (error) => {
        if (error.code === error.PERMISSION_DENIED) {
        }
      })
    },
    getDistance(locLat, locLng, elLat, elLng, unit) {
      let radGeoLat = Math.PI * locLat / 180;
      let radLocLat = Math.PI * elLat / 180;

      let theta = locLng - elLng;
      let radTheta = Math.PI * theta / 180;

      let dist = Math.sin(radGeoLat) * Math.sin(radLocLat) + Math.cos(radGeoLat) * Math.cos(radLocLat) * Math.cos(radTheta);
      if (dist > 1) {
        dist = 1;
      }
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;

      if (unit === "K") { dist = dist * 1.609344 }
      if (unit === "N") { dist = dist * 0.8684 }

      return Math.round(dist * 10) / 10
    },
    getMarker() {
      this.marker = this.createMarker(this.details, 0, false)
      this.map.setCenter(this.marker.getPosition());
      this.map.setZoom(15);
    },
    createMarker(el, index, useGeocode) {
      return new this.google.maps.Marker({
        map: this.map,
        id: index,
        icon: {
          url: this.settings.pin,
          scaledSize: new google.maps.Size(35, 35),
        },
        position: {
          lat: useGeocode ? el.geometry.location.lat() : parseFloat(el.Latitude),
          lng: useGeocode ? el.geometry.location.lng() : parseFloat(el.Longitude),
        },
        __meta: {
          id: index,
          ...el,
        }
      });
    },
    init() {
      return new Promise(async resolve => {
        this.google = await gmapsInit(this.apiKey);
        this.geocoder = new this.google.maps.Geocoder();

        this.map_options = {
          clickableIcons: false,
          gestureHandling: "cooperative",
          disableDefaultUI: true,
          zoom: 15,
          center: new this.google.maps.LatLng(
            this.details.Latitude,
            this.details.Longitude,
          ),
        };

        this.map = new this.google.maps.Map(
          this.$el.querySelector(".map"),
          this.map_options
        );
        resolve();
      })
    },
  },
  async created() {
    //await this.findLocation();
    await this.init();
    await this.getMarker();
  },
};




</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.location-detail {
  * {
    font-family: 'News Gothic', Sans-Serif, sans-serif;
  }

  &__hero {
    height: 25rem;
    position: relative;
  }

  &__background {
    position: absolute;
    top: 0;
    bottom: 0;
    height: 25rem;
    width: 100vw;
    left: 50%;
    transform: translateX(-50%);
    background-size: cover;
    background-position: center;
    object-fit: cover;
    z-index: 0;
  }

  &__header {
    display: flex;
    padding-bottom: 2rem;
    border-bottom: 1px solid #D8D8D8;
    margin: 2rem 0;

    @include mqdn(md) {
      flex-direction: column;
      //height: unset;
    }

    .header {
      &__details {
        flex: 1;
      }

      &__actions {
        margin-top: auto;

        @include mqdn(md) {
          display: flex;
          flex-direction: column;
        }
      }

      &__eyebrow {
        margin: 0 0 1rem 0;
        font-size: 1rem;
        text-transform: uppercase;
        color: $red;
      }

      &__name {
        font-weight: bold;
        font-size: 3.125rem;
        margin: 0 0 1rem 0;
      }

      &__copy {
        font-size: 1rem;
        margin: 0 0 .5rem 0;
      }

      &__btn {
        margin-right: 1rem;
        height: 3rem;
        font-size: 1rem;
        cursor: pointer;
        background: $red;
        border-radius: .5rem;
        padding: 1rem 1.5rem;
        border: 0;
        color: $white;
        text-decoration: none;
        text-align: center;
        line-height: 1;

        &:hover {
          background: darken($red, 10%);
        }

        @include mqdn(md) {
          height: unset;
          margin-right: 0;
          margin-top: 1rem;
        }
      }
    }
  }

  &__content {
    display: flex;

    @include mqdn(xl) {
      flex-direction: column-reverse;
      height: unset;
    }

    &-hours {
      flex: 1;
      overflow-y: auto;
      padding-right: 1rem;

      @include mqdn(xl) {
        padding-right: 0;
        padding-top: 1rem;
        flex: unset;
      }
    }

    &-map {
      flex: 0 0 43rem;

      @include mqdn(xl) {
        flex: 20rem;
      }

      .map {
        height: 23rem;
      }
    }
  }

  .branch {
    &__alert-flair {
      font-weight: 700;
      font-size: .875rem;
      display: inline-block;
      margin-right: auto;
      margin-bottom: .5rem;
      padding: .5rem;
      border: 1px solid $red;
      border-radius: .25rem;
      color: $red;
      line-height: 1;
    }

    &__alert-copy {}

    &__hours {
        padding-top: 1rem;
      &-message {
        font-weight: 700;
        font-size: 1.2rem;
        padding-bottom: 1rem;

        p {
          padding-left: 1rem;
          font-weight: normal;
          font-size: 1rem;
          color: #018528;
          display: inline-block;
        }

        &.closed p {
          color: $red;
        }
      }

      &-details {
        span {
          margin-bottom: .5rem;
          display: flex;

          &.active p {
            font-weight: 700;
          }

          p {
            margin: 0;
          }

          p:first-of-type {
            width: 8rem;
          }
        }
      }
    }

    &__atm {
      padding-top: 1rem;

      &-message {
        font-weight: 700;
        font-size: 1.2rem;
      }

      &-details {
        padding-top: 1rem;
        margin: 0;
      }
    }

    &__events {

      h2 {
        margin: 1.5rem 0 1.5rem;
        font-size: 2.0rem;
        font-weight: normal;
      }
      .event-detail__event:not(:last-of-type) {
        padding-bottom: 1rem;
        margin-bottom: 1rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      }

      .event-detail__location:not(:last-of-type) {
        margin-bottom: 2rem;
      }

      .event-detail__details {
        h3 {
          margin: 0;
          font-size: 1.5rem;
        }

        h4 {
          font-weight: normal;
          font-size: 1rem;
          position: relative;
          padding: 1rem 0 0.25rem 0;
          margin: 0 0 0.5rem 0;

          &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 30px;
            height: 1px;
            background: #979797;
          }
        }

        p.event-detail__value {
          margin: 0;
          font-weight: 700;
          font-size: 1.2rem;
        }

        .event-detail__ctas {
          margin-top: .5rem;
        }

        .info {
          margin-top: 1rem;
        }

      }

    }

    &__holiday-closures {
      color: #005580;
      padding-left: 0;
      background: none;
      border: none;
      margin-top: 1rem;
      font-size: 1rem;
      cursor: pointer;

      &:hover {
        color: darken(#005580, 10%);
      }

      &:after {
        margin-left: .5rem;
        position: relative;
        top: -.2em;
        content: '';
        display: inline-block;
        width: 0.4em;
        height: 0.4em;
        border-right: 0.2em solid #005580;
        border-top: 0.2em solid #005580;
        transform: rotate(135deg);
      }

      &-details {
        padding-top: .5rem;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.25s ease-out;

        &.visible {
          max-height: 1000px;
        }

        &:deep(p) {
          display: flex;
          padding-bottom: .25rem;
          margin: 0;

          span {
            margin: 0;
          }

        }

        &:deep(.branch__holiday-closures-title) {
          font-weight: 700;
        }

        &:deep(.branch__holiday-closures-description) {
          padding-left: .5rem;
        }
      }
    }
  }
}
</style>
